export const STATUS_SERVICO: any = {
    1: "Aguardando Parceiro",
    2: "Parceiro OK",
    3: "Visita Agendada",
    4: "Cliente OK",
    5: "Finalizado",
    6: "Cancelado"
}